import { WISHLIST } from '@/api'
import { uiHelper } from '@/utils'
const MODULE_NAME = 'wishlist'

/* Define Action Name */
const A_FETCH_WISHLIST = 'fetchWishlist'
const A_SEND_TO_CART = 'sendToCart'
const A_ADD_WISHLIST = 'addWishlist'
const A_DELETE_WISHLIST = 'deleteWishlist'

/* Define Getter Name */
const G_AVAILABLE_WISHLIST_ITEMS = 'availableWishlistItems'
const G_UNAVAILABLE_WISHLIST_ITEMS = 'unavailableWishlistItems'

/* Define Mutation Name */
const M_SET_WISHLIST = 'setWishlist'
const M_SELECT_ITEM_FOR_CART = 'selectItemForCart'
const M_CANCEL_ITEM_FOR_CART = 'cancelItemForCart'

/* Define Export Name */
export const SET_WISHLIST = `${MODULE_NAME}/${M_SET_WISHLIST}`

const state = {
  wishlist: [],
  itemToAddCart: {}
}

const getters = {
  [G_AVAILABLE_WISHLIST_ITEMS](state) {
    return state.wishlist.filter((item) => item.is_exist)
  },
  [G_UNAVAILABLE_WISHLIST_ITEMS]: (state) => state.wishlist.filter((item) => !item.is_exist)
}

const actions = {
  async [A_FETCH_WISHLIST]({ commit }) {
    if (uiHelper.getLocalStorage('token')) {
      await WISHLIST.getWishlist().then((res) => {
        commit(M_SET_WISHLIST, res.product)
      })
    }
  },
  [A_SEND_TO_CART]({ commit }, quantity) {
    // will need quantity when making api call. console logging for now
    // should also dispatch a mutation to remove from wishlist, or an action to re-fetch wishlist
    return new Promise((resolve) => {
      console.log(quantity)
      commit(M_CANCEL_ITEM_FOR_CART)
      resolve(true)
    })
  },
  async [A_ADD_WISHLIST]({ commit, dispatch }, data) {
    await WISHLIST.addWishlist(data).then((res) => {
      dispatch(A_FETCH_WISHLIST)
    })
  },
  async [A_DELETE_WISHLIST]({ dispatch }, data) {
    await WISHLIST.deleteWishlist(data).then((res) => {
      dispatch(A_FETCH_WISHLIST)
    })
  }
}

const mutations = {
  [M_SET_WISHLIST](state, wishlist) {
    state.wishlist = wishlist
  },
  [M_SELECT_ITEM_FOR_CART](state, itemForCart) {
    state.itemToAddCart = itemForCart
  },
  [M_CANCEL_ITEM_FOR_CART](state) {
    state.itemToAddCart = {}
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
